module.exports = __webpack_public_path__ + "img/funding-new9.acce6252.png";